// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .addButton_QdcpM {
    border-radius: 0 !important;
    width: 100%;
  }

.editor_dmmxh {
  min-height : 65vh;
  min-width : 65vw;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes-graphs/lib/editors/valueRange/ValueRangesEditor.css"],"names":[],"mappings":"EAAE;IACE,2BAA2B;IAC3B,WAAW;EACb;;AAEF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["  .addButton {\n    border-radius: 0 !important;\n    width: 100%;\n  }\n\n.editor {\n  min-height : 65vh;\n  min-width : 65vw;\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addButton": `addButton_QdcpM`,
	"editor": `editor_dmmxh`
};
export default ___CSS_LOADER_EXPORT___;
